import { api } from './api'

export interface PushSubscribePayload {
  endpoint: string
  keys: { p256dh: string; auth: string }
  user_agent?: string
}

export const pushApi = {
  subscribe: (payload: PushSubscribePayload) =>
    api.post('/v1/push/subscribe', payload).then((r) => r.data),
  unsubscribe: (endpoint: string) =>
    api.delete('/v1/push/subscribe', { data: { endpoint } }).then((r) => r.data),
  sendTest: () => api.post<{ sent: number }>('/v1/push/test').then((r) => r.data),
}
